import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * Store tour: bridge tra AppTopbar (che chiama start()) e il componente
 * TourGuideManager nella view corrente (che registra la callback via useTour).
 */
export const useTourStore = defineStore('tour', () => {
  const starter = ref<(() => void) | null>(null)

  // Quando true, il popup di benvenuto e' in gioco: l'auto-start del tour
  // (useTour) viene sospeso e sara' il popup ad avviarlo alla chiusura.
  const welcomeGated = ref(false)

  // Avvio automatico rinviato perché il popup di benvenuto era ancora «in gioco»: parte quando
  // l'attesa finisce. Prima veniva semplicemente scartato: se la risposta sul popup arrivava dopo
  // il controllo del tour — cosa normale con un server lento come preprod — il popup risultava
  // già visto, toglieva l'attesa, e il tour non partiva più per nessuno.
  const autoStartRinviato = ref<(() => void) | null>(null)

  function register(fn: () => void): void {
    starter.value = fn
  }

  function clear(): void {
    starter.value = null
    autoStartRinviato.value = null
  }

  function start(): void {
    starter.value?.()
  }

  function gateWelcome(): void {
    welcomeGated.value = true
  }

  /**
   * Toglie l'attesa. Se nel frattempo un tour aveva chiesto di partire, lo avvia ora.
   * @returns true se ha avviato un tour rinviato
   */
  function ungateWelcome(): boolean {
    welcomeGated.value = false
    const rinviato = autoStartRinviato.value
    autoStartRinviato.value = null
    if (rinviato) {
      rinviato()
      return true
    }
    return false
  }

  function rinviaAutoStart(fn: () => void): void {
    autoStartRinviato.value = fn
  }

  return { starter, welcomeGated, register, clear, start, gateWelcome, ungateWelcome, rinviaAutoStart }
})
